import { z } from 'zod';

/**
 * `activity.extra_data` of the trigger-written onboarding rows
 * (hasura-crm/migrations/crm/1791901637516_log_onboarding_milestones):
 * `onboarding_status_changed` carries the old and new `users.onboarding_status`,
 * `agent_profile_visibility_changed` the old and new `show_in_agency_pages`.
 */
const OnboardingStatusChangeSchema = z.object({
  from: z.string().nullable().optional(),
  to: z.string().nullable().optional(),
});

const ProfileVisibilityChangeSchema = z.object({
  to: z.boolean().nullable().optional(),
});

export type OnboardingStatusHeadline =
  | 'opened'
  | 'submitted'
  | 'approved'
  | 'sent_back'
  | 'changed';

export const getOnboardingStatusHeadline = (
  raw: unknown,
): OnboardingStatusHeadline => {
  const result = OnboardingStatusChangeSchema.safeParse(raw);
  if (!result.success) {
    return 'changed';
  }
  const { from, to } = result.data;
  if (to === 'pending_review') {
    return 'submitted';
  }
  if (to === 'approved') {
    return 'approved';
  }
  if (to === 'in_progress') {
    return from == null ? 'opened' : 'sent_back';
  }
  return 'changed';
};

/** null when the row is unreadable: the caller falls back to a neutral title. */
export const parseProfileVisibilityPublished = (
  raw: unknown,
): boolean | null => {
  const result = ProfileVisibilityChangeSchema.safeParse(raw);
  return result.success ? result.data.to ?? false : null;
};
